import React from "react";
import { Loading } from "@evertrue/et-components";
import { useChatNavigationContext } from "../contexts/chat-navigation-context";
import { useChatCurrentUser } from "../contexts/chat-current-user-context";
import ChatHome from "./chat-home";
import ChatRoomList from "./chat-room-list";
import useWebNotifications from "../hooks/use-web-notifications";
import ChatRoomRoutes from "./chat-room-routes";
import { useChatDependencyContext } from "../contexts/chat-dependency-context";

const getRoutes = (roomId, url = "home") => {
  const routes = {
    home: <ChatHome />,
    list: <ChatRoomList />,

    // reset state - clears out the state - messages
    // if you switch from 1 room to the other without mounting ChatRoomList first, state will persist
    room: <ChatRoomRoutes key={roomId} roomId={roomId} url={url} />,
  };
  if (url.includes("room")) return routes.room;

  return routes[url];
};
const ChatRoutes = () => {
  const [{ currentRoomId, url }] = useChatNavigationContext();
  const { currentChatUser } = useChatCurrentUser();
  const { isMobile } = useChatDependencyContext();
  // call this here b/c we only want to prompt user when they first open the chat panel
  useWebNotifications(isMobile);

  return <>{currentChatUser && currentChatUser.id ? getRoutes(currentRoomId, url) : <Loading />}</>;
};

ChatRoutes.propTypes = {};

export default ChatRoutes;
